export const usersInitialState = [
  {
    id: 1,
    name: 'Michael Thompson',
    email: 'michael.t@reinsure.com',
    phone: '+1 (555) 123-4567',
    company: 'Global Reinsurance Corp',
    userType: 'reinsurer',
    role: 'Senior Underwriter',
    status: 'active',
    joinDate: '2023-01-15',
    avatar: 'MT',
    lastActive: '2 hours ago',
    policiesManaged: 45,
    department: 'Underwriting',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    email: 'sarah.chen@premiumins.com',
    phone: '+1 (555) 234-5678',
    company: 'Premium Insurance Ltd',
    userType: 'insurer',
    role: 'Claims Manager',
    status: 'active',
    joinDate: '2023-02-20',
    avatar: 'SC',
    lastActive: '1 hour ago',
    policiesManaged: 78,
    department: 'Claims',
  },
  {
    id: 3,
    name: 'David Martinez',
    email: 'david.m@brokergroup.com',
    phone: '+1 (555) 345-6789',
    company: 'Elite Brokers Group',
    userType: 'broker',
    role: 'Senior Broker',
    status: 'active',
    joinDate: '2023-03-10',
    avatar: 'DM',
    lastActive: '30 minutes ago',
    policiesManaged: 120,
    department: 'Sales',
  },
  {
    id: 4,
    name: 'Emily Rodriguez',
    email: 'emily.r@safeguard.com',
    phone: '+1 (555) 456-7890',
    company: 'SafeGuard Insurance',
    userType: 'insurer',
    role: 'Policy Administrator',
    status: 'active',
    joinDate: '2023-04-05',
    avatar: 'ER',
    lastActive: '5 minutes ago',
    policiesManaged: 56,
    department: 'Administration',
  },
  {
    id: 5,
    name: 'James Wilson',
    email: 'james.w@brokernet.com',
    phone: '+1 (555) 567-8901',
    company: 'BrokerNet Solutions',
    userType: 'broker',
    role: 'Insurance Broker',
    status: 'inactive',
    joinDate: '2023-05-12',
    avatar: 'JW',
    lastActive: '2 days ago',
    policiesManaged: 34,
    department: 'Sales',
  },
  {
    id: 6,
    name: 'Linda Parker',
    email: 'linda.p@globalre.com',
    phone: '+1 (555) 678-9012',
    company: 'Global Re Solutions',
    userType: 'reinsurer',
    role: 'Risk Analyst',
    status: 'active',
    joinDate: '2023-06-18',
    avatar: 'LP',
    lastActive: '10 minutes ago',
    policiesManaged: 67,
    department: 'Risk Management',
  },
  {
    id: 7,
    name: 'Robert Kumar',
    email: 'robert.k@trustins.com',
    phone: '+1 (555) 789-0123',
    company: 'Trust Insurance Co.',
    userType: 'insurer',
    role: 'Underwriter',
    status: 'pending',
    joinDate: '2023-07-22',
    avatar: 'RK',
    lastActive: '1 day ago',
    policiesManaged: 12,
    department: 'Underwriting',
  },
  {
    id: 8,
    name: 'Alexandra Brown',
    email: 'alex.b@brokerplus.com',
    phone: '+1 (555) 890-1234',
    company: 'BrokerPlus Associates',
    userType: 'broker',
    role: 'Lead Broker',
    status: 'active',
    joinDate: '2023-08-30',
    avatar: 'AB',
    lastActive: '15 minutes ago',
    policiesManaged: 98,
    department: 'Sales',
  },
];
